import React from 'react'
import '../../App.css'
import './Workshop.css'
import { Link } from 'react-router-dom'
import Fade from 'react-reveal/Fade'
import Zoom from 'react-reveal'
import { MdDownloadDone } from 'react-icons/md'
 export const WorkshopDetail2 = () => {
  return (
    <>
      <Fade right>
        <section className="container-fluid workshop1">
          <div className="container">
          <h2>TO PEOPLE WHO WANT TO BE AN ENTREPRENEUR</h2>
          </div>
        </section>
      </Fade>
      <section className="container m-auto w-75">
        <Zoom>

        <h1><span>What is this workshop  about?</span></h1>
        </Zoom>
        <p>
          Lacuna Venture startup workshop introduces you to the entrepreneurial world and
          provides hands on sustaining your startup ideas. Entrepreneurs develop confidence,
          creativity, and possess the necessary skills to build sustainable startups. These
          programs offer leadership opportunities for senior leaders who are already experts or
          willing entrepreneurs with strong interpersonal relationships. Willing entrepreneurs learn
          from professional mentors about how to make it into corporate leadership positions
          across multiple industries.
        </p>
        <p>
          We are committed not only to creating long term opportunities but sharing value along
          those routes.
        </p>

        <p>
          Do you have an idea that can impact socially? You are just a step back.
        </p>
        <p className="text-center mt-5"> <b> Claim the entrepreneurial realm!!</b>  </p>
        <div className="auto">
        <Link to='/appMember'>  <button className="btn btn-pri ">Register now</button></Link>
        </div>

        <Fade right>

          <section className="mission1  ">

            <h2>Objectives</h2>
    

            <ul >
              <li><a href="">Assist members with understanding the process, difficulties in the transition
                phase of entrepreneurship with a focal point of building up a field-tested strategy
                that can be introduced to financial specialists.


              </a></li>
              <li><a href=""> Incorporate numerous but not limited mini-presentations, exercise and
                mentorship young dreams and talents to empower members to adapt their
                business thoughts into noteworthy field-tested strategies.</a></li>
              <li><a href="">Furnish the young talents and dreams with the resources required to sustain
                start-up businesses.</a></li>
              <li><a href=""> Architecting the dream and project with your crucial and inspiring vision.</a></li>
            </ul>
          </section>
        </Fade>

        <section className=' container  icontext'>
            <div className="text-center">

          <span className="subtitle ">Here is exactly</span>
            </div>
          <h1 className='text-center'>WHAT YOU WILL LEARN WHEN YOU JOIN THE <span>LACUNA VENTURE</span> </h1>
          <div className="row">
            <div className="col-md-5 col-sm-12">
              <div className="d-flex align-items-center mb-3">
                <div className="flex-shrink-0">
                  <MdDownloadDone size="4em" color="#fa7525" />
                </div>
                <div className="flex-grow-1 ms-3 bg-light p-1">
                  <p> Help entrepreneurs and startup founders systematically extract, educate, learn, and apply those human-centered techniques to solve problems</p>
                </div>
              </div>
              <div className="d-flex align-items-center mb-3">
                <div className="flex-shrink-0">
                  <MdDownloadDone size="4em" color="#fa7525" />
                </div>
                <div className="flex-grow-1 ms-3 bg-light p-1">
                  <p>Our community provides many support platforms for development from mentors including: peer review system that helps identify key problems before even starting work; </p>
                </div>
              </div>
              <div className="d-flex align-items-center mb-3">
                <div className="flex-shrink-0">
                  <MdDownloadDone size="4em" color="#fa7525" />
                </div>
                <div className="flex-grow-1 ms-3 bg-light p-1">
                  <p> We offer all the components required to create an innovative startup ​​including business plan designing and marketing strategy building, digitalization skills needed to launch your own services, </p>
                </div>
              </div>
            </div>
           <div className="col-md-2 col-sm-0 "></div>
            <div className="col-md-5 col-sm-12 ">
              <div className="d-flex align-items-center mb-3">
                <div className="flex-shrink-0">
                  <MdDownloadDone size="4em" color="#fa7525" />
                </div>
                <div className="flex-grow-1 ms-3 bg-light p-1">
                  <p>learn from professional mentors about how to make it into corporate leadership positions across multiple industries.  </p>
                </div>
              </div>
              <div className="d-flex align-items-center mb-3">
                <div className="flex-shrink-0">
                  <MdDownloadDone size="4em" color="#fa7525" />
                </div>
                <div className="flex-grow-1 ms-3 bg-light p-1">
                  <p>We  furnish your experience in entrepreneurship through design thinking skills like improving productivity and investing capital into ideas, so they'll take off faster than you anticipated. </p>
                </div>
              </div>
              <div className="d-flex align-items-center mb-3">
                <div className="flex-shrink-0">
                  <MdDownloadDone size="4em" color="#fa7525" />
                </div>
                <div className="flex-grow-1 ms-3 bg-light p-1">
                  <p>We  furnish your experience in entrepreneurship through design thinking skills like improving productivity and investing capital into ideas, so they'll take off faster than you anticipated. </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </>
  )
}